import CheckIcon from "../../assets/icons/checkIcon";
import Button from "../../components/button";
import PopUp, { closePopUp } from "../../components/popUp";
import { useAppContext } from "../../context/appContext";
import { PayoutResponseDTO } from "../../openapi-generated-client";
import { formatDate } from "../../utils/dateUtils";

interface PayOutInfoPopUpProps {
    data: PayoutResponseDTO;
    refetch?: () => void;
}

export default function PayOutInfoPopUp(props: PayOutInfoPopUpProps) {

    const {payoutController, sessionId} = useAppContext();

    return <PopUp className="big" title="Pay out request">
        <div className="columns">
            <div className="column left">
                <div className="grid-element">
                    <h4>Request Date</h4>
                    <p>{formatDate(new Date(props.data.date))}</p>
                </div>
                {props.data.closed ? <div className="grid-element">
                    <h4>Fulfill Date</h4>
                    <p>{props.data.closedDate ? formatDate(new Date(props.data.closedDate)) : "-"}</p>
                </div> : <></>}
                <div className="grid-element">
                    <h4>Account Name</h4>
                    <p>{props.data.artist}</p>
                </div>
                <div className="grid-element">
                    <h4>Amount</h4>
                    <p>{props.data.amount} €</p>
                </div>
            </div>
            <div className="column right">
                <div className="grid-element">
                    <h4>Iban</h4>
                    <p>{props.data.iban}</p>
                </div>
                <div className="grid-element">
                    <h4>Bic</h4>
                    <p>{props.data.bic}</p>
                </div>
                <div className="grid-element">
                    <h4>Recipient</h4>
                    <p>{props.data.recipient}</p>
                </div>

            </div>
        </div>
        {!props.data.closed ? <Button extraPadding thin onClick={async () => {
            payoutController.closePayOutRequest(sessionId, props.data.id).then( async () => {
                closePopUp();
                props.refetch? props.refetch() : <></>;
            });
        }
        }><CheckIcon/></Button> : <></>}
    </PopUp>
}